import { TextField } from '@loadsmart/miranda-react'
import styled from 'styled-components'

export const StyledTextField = styled(TextField)`
    margin-bottom: 1em;
`

/**
 * Optional lead-in copy above the form, used when the caller needs to say what
 * the visitor is requesting.
 */
export const StyledDialogDescription = styled.div`
  margin-bottom: var(--m-spacing-4);
`
